export default __webpack_public_path__ + "static/media/prbicon_LawNuevo.f015b26e.svg";